<template>
  <div>
Test Test Test
  </div>
</template>

<script>
export default {
  name: "detail3",
};
</script>

<style scoped>

</style>
